import { render, staticRenderFns } from "./FortSafety.vue?vue&type=template&id=3880bb2d&scoped=true&"
import script from "./FortSafety.vue?vue&type=script&lang=js&"
export * from "./FortSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880bb2d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3880bb2d')) {
      api.createRecord('3880bb2d', component.options)
    } else {
      api.reload('3880bb2d', component.options)
    }
    module.hot.accept("./FortSafety.vue?vue&type=template&id=3880bb2d&scoped=true&", function () {
      api.rerender('3880bb2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/referrer/FortSafety.vue"
export default component.exports